var Direction;
(function (Direction) {
  Direction["rtl"] = "rtl";
  Direction["ltr"] = "ltr";
  Direction["auto"] = "auto";
})(Direction || (Direction = {}));

export { Direction as D };
